module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiI+CiAgICA8ZGVmcz4KICAgICAgICA8cGF0aCBpZD0iYSIgZD0iTTE2IDBDNy4xNjggMCAwIDcuMTY4IDAgMTZzNy4xNjggMTYgMTYgMTYgMTYtNy4xNjggMTYtMTZTMjQuODMyIDAgMTYgMHptLTMuMiAyNGwtOC04IDIuMjU2LTIuMjU2IDUuNzQ0IDUuNzI4TDI0Ljk0NCA3LjMyOCAyNy4yIDkuNiAxMi44IDI0eiIvPgogICAgPC9kZWZzPgogICAgPHVzZSBmaWxsPSIjRjRDQjFDIiBmaWxsLXJ1bGU9Im5vbnplcm8iIHhsaW5rOmhyZWY9IiNhIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/acknowledged.svg
// module id = Yxi7
// module chunks = 1